<template>
    <div>
        <div class="loading" v-if="loading">
            <LoadingSpinner :loading="loading"/>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <Calculation v-model="calculation" :edit="false" :create="false"></Calculation>
            </div>
        </div>
    </div>
</template>

<script>
import Calculation from '@/components/Calculation.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
export default {
    components: {
        Calculation,
        LoadingSpinner
    },
    data() {
        return {
            calculation: {},
            saving: false,
            loading: true
        }
    },
    created: function () {
        this.load();
    },
    methods: {
        load: function () {
            this.loading = true;
            this.$store.getters.api.get("/calculation/" + this.$route.params.slug).then(function (response) {
                this.calculation = response.data.data;
                this.loading = false;
            }.bind(this))
        }
    }
}
</script>
<style lang="scss">
</style>